var getDisplayName = function (Component) {
    if (typeof Component === 'string') {
        return Component;
    }
    return (Component && (Component.displayName || Component.name)) || 'Unknown';
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/ban-types
export var wrapDisplayName = function (BaseComponent, wrapperName) {
    return "".concat(wrapperName, "(").concat(getDisplayName(BaseComponent), ")");
};
